import { yupResolver } from "@hookform/resolvers/yup";
import { enqueueSnackbar } from "notistack";
import React from "react";
import { Resolver, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { handleError } from "../../../shared/functions/handleError";
import { IVersionAction } from "../../../shared/interfaces/version/IVersion";
import { VersionService } from "../service";
import { versionSchema } from "./VersionCreate";
import VersionForm from "./VersionForm";
import VersionNotifications from "./VersionNotifications";

const VersionUpdate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const { handleSubmit, control } = useForm<IVersionAction>({
    resolver: yupResolver(versionSchema) as unknown as Resolver<IVersionAction>,
    defaultValues: async () =>
      (await VersionService.getSingle(Number(id))
        .then((response) => {
          return {
            ...response,
          };
        })
        .catch(handleError)) as unknown as IVersionAction,
  });
  const submitHandler = (formData: IVersionAction) => {
    VersionService.update(formData, Number(id))
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t("toasts.successfullyUpdated", { title: formData?.version }),
            {
              variant: "success",
            },
          );
        }
      })
      .catch(handleError);
  };

  return (
    <>
      <form onSubmit={handleSubmit(submitHandler)}>
        <VersionForm isUpdate control={control} />
      </form>
      <VersionNotifications versionId={Number(id)} />
    </>
  );
};

export default VersionUpdate;
